import {AdminAxios} from "../../common/Axios";

const ACTION_URL = '/media/revision';

const INVENTORY_LIST =ACTION_URL+'/inventory'
const AD_EX_INVENTORY_LIST =ACTION_URL+'/ad-exchange'

export async function selHistoryList(searchParams) {
  const params = {
    ...searchParams,
    searchKeywordType: searchParams.searchKeywordType?.value
  }
  try {
    const response = await AdminAxios('POST', INVENTORY_LIST, params);
    const status = response?.statusCode ?? response?.responseCode?.statusCode;
    return status === 200 ? response?.data ?? null : null;
  } catch (e) {
    return null;
  }
}

export async function selHistoryInfo(revId) {
  if (!revId) return null;
  try {
    const response = await AdminAxios('GET', ACTION_URL+'/'+revId+'/inventory', null);
    const status = response?.statusCode ?? response?.responseCode?.statusCode;
    return status === 200 ? response?.data ?? null : null;
  } catch (e) {
    return null;
  }
}

export async function selAdExChangeHistoryList(searchParams) {
  let returnVal = null;
  const params = {
    ...searchParams,
    searchKeywordType: searchParams.searchKeywordType?.value
  }
  await AdminAxios('POST', AD_EX_INVENTORY_LIST, params)
    .then((response) => {
      const {responseCode,data} =response
      if (responseCode.statusCode === 200) {
        returnVal = data
      } else {
        returnVal = null
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}

export async function selAdExChangeHistoryInfo(params) {
  let returnVal = null;
  await AdminAxios('GET', ACTION_URL+'/'+params.revId+'/ad-exchange/'+params.inventoryExchangeId, null)
    .then((response) => {
      const {responseCode,data} =response
      if (responseCode.statusCode === 200) {
        returnVal = data
      } else {
        returnVal = null
      }
    }).catch((e) => returnVal = false)
  return returnVal;
}
